export * from './no-content.component';


// WEBPACK FOOTER //
// ./src/app/shared/no-content/index.ts